<div class="alert alert-{{ type }}" fxLayout="row">
  <mat-icon>{{ type }}</mat-icon>
  <span class="message">{{ message }}</span>
</div>
